var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-sm text-black flex-center",attrs:{"role":"button"},on:{"click":_vm.back}},[_c('i',{staticClass:"el-icon-back font-lg"})])}
var staticRenderFns = []

export { render, staticRenderFns }